<div class="auth-shell">

  <!-- ============ LEFT · BRAND HERO ============ -->
  <aside class="auth-hero">
    <div class="hero-inner">
      <div class="hero-logo">
        <img src="../../../assets/arogyaLOGO.png" alt="Arogya Kavach" />
      </div>

      <div class="hero-copy">
        <h1 class="hero-title">Smart Solutions<br />for a <span>Healthier Tomorrow</span></h1>
        <p class="hero-lede">Secure. Reliable. Dedicated to protecting what matters most.</p>
      </div>

      <ul class="hero-features">
        <li>
          <span class="hf-ico"><i class="pi pi-shield"></i></span>
          <div><b>Secure Access</b><small>Your data is protected with advanced security</small></div>
        </li>
        <li>
          <span class="hf-ico"><i class="pi pi-users"></i></span>
          <div><b>Easy &amp; Reliable</b><small>Seamless access to your information anytime</small></div>
        </li>
        <li>
          <span class="hf-ico"><i class="pi pi-heart"></i></span>
          <div><b>Better Healthcare</b><small>Technology driven solutions for better outcomes</small></div>
        </li>
      </ul>

      <div class="hero-shield" aria-hidden="true">
        <svg viewBox="0 0 200 230" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="fpShieldFill" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stop-color="#eaf6ff" />
              <stop offset="0.5" stop-color="#8fd0f5" />
              <stop offset="1" stop-color="#2f7fd1" />
            </linearGradient>
            <linearGradient id="fpShieldEdge" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stop-color="#ffffff" />
              <stop offset="1" stop-color="#cfe6f7" />
            </linearGradient>
          </defs>
          <ellipse class="shield-halo" cx="100" cy="150" rx="86" ry="22" />
          <path class="shield-edge" d="M100 8 L182 40 V120 C182 170 146 205 100 222 C54 205 18 170 18 120 V40 Z"
                fill="url(#fpShieldEdge)" />
          <path d="M100 20 L170 47 V119 C170 162 140 193 100 208 C60 193 30 162 30 119 V47 Z"
                fill="url(#fpShieldFill)" />
          <path class="shield-cross" d="M88 78 H112 V102 H136 V126 H112 V150 H88 V126 H64 V102 H88 Z" fill="#ffffff" />
        </svg>
      </div>

      <p class="hero-trust"><i class="pi pi-verified"></i> Your trust is our commitment.</p>
    </div>
  </aside>

  <!-- ============ RIGHT · FORGOT PASSWORD ============ -->
  <main class="auth-panel">
    <div class="auth-card">
      <h2 class="auth-welcome">Forgot <span>Password?</span></h2>
      <p class="auth-sub">Enter your username, email or mobile number and we'll send you a one-time code to reset it.</p>

      <form [formGroup]="forgotForm" (ngSubmit)="onSendOtp()" class="auth-form">
        <div class="field">
          <span class="field-ico"><i class="pi pi-user"></i></span>
          <input type="text" formControlName="identifier" placeholder="Username / Email / Mobile" autocomplete="username" />
        </div>
        @if (forgotForm.get('identifier')?.touched && forgotForm.get('identifier')?.invalid) {
          <small class="field-err">This field is required</small>
        }

        <button class="auth-submit" type="submit" [disabled]="loading()">
          @if (loading()) {
            <span class="spinner-border spinner-border-sm"></span> Sending OTP…
          } @else {
            Send OTP <i class="pi pi-arrow-right"></i>
          }
        </button>
      </form>

      <div class="auth-secure">
        <span class="line"></span>
        <span class="txt"><i class="pi pi-shield"></i> Secure reset</span>
        <span class="line"></span>
      </div>

      <a class="auth-back" routerLink="/login"><i class="pi pi-arrow-left"></i> Back to Login</a>
    </div>
  </main>
</div>

<!-- ===================== RESET PASSWORD MODAL ===================== -->
<p-dialog [visible]="showResetModal()" (visibleChange)="showResetModal.set($event)" [modal]="true"
    [draggable]="true" [resizable]="false" [closable]="true" [dismissableMask]="false"
    [closeOnEscape]="false" (onShow)="onResetModalShow()" styleClass="otp-dialog"
    [style]="{ width: '440px' }" [breakpoints]="{ '480px': '92vw' }">
    <ng-template pTemplate="header">
        <div class="otp-header">
            <h3 class="otp-title mb-1">Reset Password</h3>
            <p class="otp-subtitle mb-0">Enter the OTP and choose a new password.</p>
        </div>
    </ng-template>

    <div class="otp-body" [formGroup]="resetForm">
        <label class="otp-label">Enter OTP</label>
        <div class="otp-inputs" (paste)="onPaste($event)">
            @for (ctrl of otpArray.controls; track i; let i = $index) {
                <input #otpInput type="text" inputmode="numeric" maxlength="1"
                    class="otp-box" [formControl]="ctrl"
                    (input)="onInput($event, i)" (keydown)="onKeyDown($event, i)">
            }
        </div>

        <div class="otp-meta">
            <span class="otp-timer" [class.expired]="expired()">
                @if (expired()) { OTP expired } @else { Expires in {{ countdown() }} }
            </span>
            <button type="button" class="otp-resend" (click)="resendOtp()" [disabled]="resendLoading()">
                @if (resendLoading()) {
                    <span class="spinner-border spinner-border-sm me-1"></span> Sending...
                } @else {
                    Resend OTP
                }
            </button>
        </div>

        <label class="otp-label mt-3">New Password</label>
        <div class="otp-password">
            <p-password formControlName="newPassword" [toggleMask]="true" [feedback]="false"
                [fluid]="true" placeholder="Enter new password" />
        </div>
        @if (newPassword?.touched && newPassword?.invalid) {
            <small class="text-danger d-block mt-1">Password must be at least 6 characters</small>
        }

        <div class="otp-actions">
            <button type="button" class="btn btn-outline-secondary" (click)="closeResetModal()">
                Cancel
            </button>
            <button type="button" class="btn btn-primary" (click)="onResetPassword()"
                [disabled]="resetLoading() || expired()">
                @if (resetLoading()) {
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    Updating...
                } @else {
                    Update Password
                }
            </button>
        </div>
    </div>
</p-dialog>
